/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.storefront.service.rpc.MarketplaceStorefrontPublicRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getSearchFilterConfigRpc = {
  serviceName: 'com.hubspot.marketplace.storefront.service.rpc.MarketplaceStorefrontPublicRpc',
  rpcName: 'getSearchFilterConfig',
  auth: 'external',
  fingerprint: 'WjgoerRds_glkXwfPjdc75wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPaginatedSearchFilterOptionsRpc = {
  serviceName: 'com.hubspot.marketplace.storefront.service.rpc.MarketplaceStorefrontPublicRpc',
  rpcName: 'getPaginatedSearchFilterOptions',
  auth: 'external',
  fingerprint: 'unUTtSH07dwZqsEVlj9Wj5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getBatchSearchFilterOptionsRpc = {
  serviceName: 'com.hubspot.marketplace.storefront.service.rpc.MarketplaceStorefrontPublicRpc',
  rpcName: 'getBatchSearchFilterOptions',
  auth: 'external',
  fingerprint: 'AvGlt1OjWd1ntJD5s0o_lZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};